export let tabOptions = [
  {
    label:"基本信息",
    value:"trust-detail"
  },
  {
    label:"样品列表",
    value:"sample-list"
  }
]